import $ from 'jquery'

$( document ).on( 'cartzillagb_seller_block_output_success', function( e, el, response, attributes ) {
    if( $( `#${attributes.blockId}` ).length && typeof $( `#${attributes.blockId}` ).data( 'slick-attributes' ) !== undefined && $( `#${attributes.blockId}` ).find( '.products' ).length ) {
        if( $( `#${attributes.blockId}` ).find( '.products' ).attr( 'data-slick' ) === undefined ) {
            let slickAttributes = JSON.parse( $( `#${attributes.blockId}` ).attr( 'data-slick-attributes' ) )
            const slickClasses = $( `#${attributes.blockId}` ).data( 'slick-classes' )
            const slickId = $( `#${attributes.blockId}` ).attr( 'id' )

            if( slickAttributes && slickAttributes.customArrows ) {
                if( $( `#${attributes.blockId}` ).find( '.slick-arrow' ) && $( `#${attributes.blockId}` ).find( '.slick-arrow' ).length > 0 ) {
                    $( `#${attributes.blockId}` ).find( '.slick-arrow' ).remove()
                }
                slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
            }

            if( slickAttributes && $('body,html').hasClass('rtl') ) {
                slickAttributes = { ...slickAttributes, rtl: true }
            }

            $( `#${attributes.blockId}` ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
            $( `#${attributes.blockId}` ).find( '.products' ).addClass( slickClasses )
            $( `#${attributes.blockId}` ).find( '.products' ).slick()
        }
    }
})